import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ color: '#333', marginBottom: '30px' }}>Privacy Policy</h1>
        
        <div style={{ lineHeight: '1.6', color: '#555' }}>
          <h2>8K Getter SMS Alert Service</h2>
          <p><strong>Effective Date:</strong> August 27, 2024</p>
          
          <h3>1. Information We Collect</h3>
          <p>We collect the following information to provide our SMS alert service:</p>
          <ul>
            <li><strong>Phone Number:</strong> Required for SMS delivery and verification</li>
            <li><strong>Ticker Preferences:</strong> Stock symbols you want to monitor</li>
            <li><strong>Form Type Preferences:</strong> Types of SEC filings you want alerts for</li>
            <li><strong>Usage Data:</strong> SMS delivery status and opt-out requests</li>
          </ul>
          
          <h3>2. How We Use Your Information</h3>
          <p>Your information is used exclusively to:</p>
          <ul>
            <li>Send SEC filing alerts via SMS</li>
            <li>Verify your phone number during registration</li>
            <li>Process opt-out requests (STOP commands)</li>
            <li>Maintain service functionality and reliability</li>
          </ul>
          
          <h3>3. Information Sharing</h3>
          <p>We do not sell, rent, or share your personal information with third parties for marketing purposes. We may share information only:</p>
          <ul>
            <li>With SMS service providers (AWS SNS, Twilio) to deliver messages</li>
            <li>When required by law or legal process</li>
            <li>To protect our rights or prevent fraud</li>
          </ul>
          
          <h3>4. Data Security</h3>
          <p>We implement industry-standard security measures including:</p>
          <ul>
            <li>Encrypted data transmission (HTTPS/TLS)</li>
            <li>Secure cloud storage with Cloudflare</li>
            <li>Access controls and authentication</li>
            <li>Regular security monitoring</li>
          </ul>
          
          <h3>5. Data Retention</h3>
          <p>We retain your information only as long as necessary to provide the service. When you opt out completely (STOP ALL), we delete your account data within 30 days.</p>
          
          <h3>6. Your Rights</h3>
          <p>You have the right to:</p>
          <ul>
            <li>Opt out of all messages (reply STOP ALL)</li>
            <li>Opt out of specific ticker alerts (reply STOP [TICKER])</li>
            <li>Request account deletion (contact jon@sum1solutions.com)</li>
            <li>Update your preferences at 8kgetter.com</li>
          </ul>
          
          <h3>7. Third-Party Services</h3>
          <p>We use the following third-party services:</p>
          <ul>
            <li><strong>AWS SNS:</strong> Primary SMS delivery service</li>
            <li><strong>Twilio:</strong> Backup SMS delivery service</li>
            <li><strong>Cloudflare:</strong> Hosting and data storage</li>
            <li><strong>SEC EDGAR:</strong> Public filing data source</li>
          </ul>
          
          <h3>8. Children's Privacy</h3>
          <p>Our service is not intended for users under 18. We do not knowingly collect information from minors.</p>
          
          <h3>9. Changes to Privacy Policy</h3>
          <p>We may update this policy periodically. Material changes will be communicated via SMS or email.</p>
          
          <h3>10. Contact Us</h3>
          <p>For privacy questions or requests, contact:</p>
          <p>Email: jon@sum1solutions.com<br/>
          Phone: +1 (401) 294-8255<br/>
          Address: 56 Hill Side St, North Kingstown, RI 02874</p>
          
          <p style={{ marginTop: '40px', fontSize: '14px', color: '#888' }}>
            © 2024 Sum1 Solutions, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
